export function valueDisplayWorth(value) {
  return value?.displayWorth ?? 0;
}

export function valueDisplayCurrency(value, fallback = 'USD') {
  return value?.displayCurrency ?? fallback;
}

export function getAbTestValueCurrency(abTest, variants = [], fallback = 'USD') {
  return (
    abTest?.totalValue?.displayCurrency ??
    variants.find((variant) => variant?.results?.value?.displayCurrency)?.results?.value?.displayCurrency ??
    fallback
  );
}

export function getDistributionValueCurrency(abTest, distributionBuckets = [], fallback = 'USD') {
  return (
    abTest?.totalValue?.displayCurrency ??
    distributionBuckets
      .flatMap((bucket) => bucket?.distribution ?? [])
      .find((item) => item?.totalValue?.displayCurrency)?.totalValue?.displayCurrency ??
    fallback
  );
}
